export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-void px-6 py-12 md:px-10" data-testid="footer">
      <div className="mx-auto flex max-w-[1400px] flex-col items-start justify-between gap-8 md:flex-row md:items-center">
        <div>
          <div className="flex items-center gap-3">
            <span className="h-2.5 w-2.5 animate-pulse bg-reactor-red" />
            <span className="font-octin text-3xl tracking-wide text-white">THINKAVARIUM</span>
          </div>
          <p className="mt-2 font-mono text-[10px] tracking-[0.3em] text-white/40 md:text-[13px]">
            SUBTERRANEAN BROADCAST STATION
          </p>
        </div>

        <div className="flex flex-wrap items-center gap-6 font-mono text-xs tracking-widest text-white/50 md:text-[15px]">
          <a
            href="https://www.youtube.com/@thinkavarium"
            target="_blank"
            rel="noopener noreferrer"
            className="transition-colors duration-100 hover:text-reactor-red"
            data-testid="footer-youtube"
          >
            YOUTUBE ↗
          </a>
          <a href="#enlist" className="transition-colors duration-100 hover:text-hazard-amber">
            ENLIST
          </a>
          <span className="text-white/30">© {new Date().getFullYear()} · ALL SIGNALS RESERVED</span>
        </div>
      </div>
    </footer>
  );
}
